<template>
  <van-popup v-model="show" position="bottom" :round="true">
    <div class="datetime-picker" v-if="done">
      <div class="picker-header">
        <div class="btn-picker cancel" @click="close">取消</div>
        <div class="btn_text">{{title}}</div>
        <div class="btn-picker submit" :class="{ activate }" @click="_onSubmit">保存</div>
      </div>
      <div class="picker-body">
        <van-picker :columns="columns" @change="onChange" :item-height="40" :visible-item-count="5" />
      </div>
    </div>
  </van-popup>
</template>

<script>
export default {
  name: 'TimePicker',
  props: {
    title: {
      type: String,
      default: '请选择您的生日',
    },
    startYear: {
      type: Number,
      default: 2000,
    },
    endYear: {
      type: Number,
      default: 2099,
    },
    timeInit: {
      type: Number,
      default: () => new Date().getTime(),
    },
  },
  data() {
    return {
      show: false,
      done: false,
      activate: false,
      selectedYear: null,
      selectedMonth: null,
      selectedDay: null,
      columns: []
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      const initDate = new Date(this.timeInit);
      this.selectedYear = initDate.getFullYear();
      this.selectedMonth = initDate.getMonth() + 1;
      this.selectedDay = initDate.getDate();
      this.initColumns();
      this.done = true;
    },
    initColumns() {
      // 年
      const years = [];
      for (let i = this.startYear; i <= this.endYear; i++) {
        years.push({ text: `${i}年`, value: i });
      }

      // 月
      const months = [];
      for (let i = 1; i <= 12; i++) {
        months.push({ text: `${i}月`, value: i });
      }

      // 日
      const days = [];
      const daysInMonth = new Date(this.selectedYear, this.selectedMonth, 0).getDate();
      for (let i = 1; i <= daysInMonth; i++) {
        days.push({ text: `${i}日`, value: i });
      }

      this.columns = [
        { values: years, defaultIndex: years.findIndex(y => y.value === this.selectedYear) },
        { values: months, defaultIndex: this.selectedMonth - 1 },
        { values: days, defaultIndex: this.selectedDay - 1 }
      ];
    },
    open() {
      this.show = true;
    },
    close() {
      this.show = false;
    },
    _onSubmit() {
      const result = {
        year: this.formatNum(this.selectedYear),
        month: this.formatNum(this.selectedMonth),
        day: this.formatNum(this.selectedDay),
        hour: '',
        minute: '',
        second: ''
      };
      this.$emit('submit', result);
      this.close();
    },
    onChange(picker, values, index) {
      this.activate = true;
      this.selectedYear = values[0].value;
      this.selectedMonth = values[1].value;
      this.selectedDay = values[2].value;

      if (index === 0 || index === 1) {
        // 更新天数
        const days = [];
        const daysInMonth = new Date(this.selectedYear, this.selectedMonth, 0).getDate();
        for (let i = 1; i <= daysInMonth; i++) {
          days.push({ text: `${i}日`, value: i });
        }
        picker.setColumnValues(2, days);
      }
    },
    formatNum(num) {
      return num < 10 ? `0${num}` : `${num}`;
    }
  }
};
</script>
<style lang="scss" scoped>
.datetime-picker {
  width: 100%;
  background: #ffffff;
  border-radius: .5rem .5rem 0 0;
  padding: 0 0 1.15rem;
  display: flex;
  align-items: center;
  flex-direction: column;
  overflow-x: hidden;

  .picker-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    justify-content: space-between;
    padding: .7rem .4rem;
    text-align: center;
  }

  .picker-body {
    width: 100%;
    height: 11.65rem;
    margin: .5rem auto 0;
    overflow: hidden;
    background-color: #fff;
  }

  .btn-picker {
    position: relative;
    display: inline-block;
    padding: 0 .5rem;
    box-sizing: border-box;
    text-align: center;
    text-decoration: none;
    line-height: 2;
    font-size: .7rem;
    border-radius: 3px;
    color: #9e9e9e;
    cursor: pointer;

    &.submit {
      font-size: .7rem;
      color: #1d1d1d;
    }

    &.activate {
      color: #1d1d1d;
    }
  }

  .btn_text {
    font-size: .875rem;
    font-weight: 700;
    color: #000;
  }
}
</style>